module.exports = __webpack_public_path__ + "static/media/p2008vid4.d1a34dcf.mp4";